import { render, staticRenderFns } from "./relatorio-detalhe-fonte-pagadora.vue?vue&type=template&id=463e32d9&scoped=true"
import script from "./relatorio-detalhe-fonte-pagadora.vue?vue&type=script&lang=js"
export * from "./relatorio-detalhe-fonte-pagadora.vue?vue&type=script&lang=js"
import style0 from "./relatorio-detalhe-fonte-pagadora.vue?vue&type=style&index=0&id=463e32d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463e32d9",
  null
  
)

export default component.exports